export const LANDING_HEADER = "Let’s get started";

export const LANDING_SUBHEADER =
  "Once you enter your phone number, you will receive a SMS text to confirm that number.";
